// Drawing App - Brush Cursor Preview

import { CanvasEngine } from './canvas_engine';
import { TransformManager } from './transform';
import { BrushSettings } from './types';

export class BrushCursor {
  private canvasEngine: CanvasEngine;
  private transformManager: TransformManager;
  private displayCanvas: HTMLCanvasElement;
  private isDrawing: boolean = false;
  private enabled: boolean = true;

  constructor(
    canvasEngine: CanvasEngine,
    transformManager: TransformManager,
    displayCanvas: HTMLCanvasElement
  ) {
    this.canvasEngine = canvasEngine;
    this.transformManager = transformManager;
    this.displayCanvas = displayCanvas;

    this.setupEvents();
  }

  private setupEvents(): void {
    this.displayCanvas.addEventListener('pointermove', (e) => {
      if (this.isDrawing || !this.enabled) return;

      const rect = this.displayCanvas.getBoundingClientRect();
      const screenX = e.clientX - rect.left;
      const screenY = e.clientY - rect.top;
      const canvasPos = this.transformManager.screenToCanvas(screenX, screenY);

      // Update cursor position - the actual rendering happens in CanvasEngine.render()
      const brushSize = this.getCurrentBrushSize();
      const brushHardness = this.getCurrentBrushHardness();
      this.canvasEngine.setBrushCursor(canvasPos.x, canvasPos.y, brushSize, brushHardness);
    });

    this.displayCanvas.addEventListener('pointerleave', () => {
      this.canvasEngine.hideBrushCursor();
    });

    this.displayCanvas.addEventListener('pointerenter', (e) => {
      if (!this.isDrawing && this.enabled) {
        const rect = this.displayCanvas.getBoundingClientRect();
        const screenX = e.clientX - rect.left;
        const screenY = e.clientY - rect.top;
        const canvasPos = this.transformManager.screenToCanvas(screenX, screenY);
        this.canvasEngine.setBrushCursor(canvasPos.x, canvasPos.y, this.getCurrentBrushSize(), this.getCurrentBrushHardness());
      }
    });
  }

  private _brushSize: number = 12;
  private _brushHardness: number = 0.8;

  private getCurrentBrushSize(): number {
    return this._brushSize;
  }

  private getCurrentBrushHardness(): number {
    return this._brushHardness;
  }

  updateBrushSettings(settings: BrushSettings): void {
    this._brushSize = settings.size;
    this._brushHardness = settings.hardness;
  }

  setDrawing(drawing: boolean): void {
    this.isDrawing = drawing;
    if (drawing) {
      this.canvasEngine.hideBrushCursor();
      this.displayCanvas.style.cursor = 'none';
    } else {
      this.displayCanvas.style.cursor = 'none';
    }
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    if (!enabled) {
      this.canvasEngine.hideBrushCursor();
      this.displayCanvas.style.cursor = 'crosshair';
    } else {
      this.displayCanvas.style.cursor = 'none';
    }
  }

  destroy(): void {
    this.displayCanvas.style.cursor = 'crosshair';
  }
}
